/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Hascontactcodes2Inputs */

const en_entity_hascontactcodes2 = /** @type {(inputs: Entity_Hascontactcodes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has Contact Codes`)
};

const de_entity_hascontactcodes2 = /** @type {(inputs: Entity_Hascontactcodes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat Kontakt Codes`)
};

/**
* | output |
* | --- |
* | "Has Contact Codes" |
*
* @param {Entity_Hascontactcodes2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_hascontactcodes2 = /** @type {((inputs?: Entity_Hascontactcodes2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Hascontactcodes2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_hascontactcodes2(inputs)
	return de_entity_hascontactcodes2(inputs)
});
export { entity_hascontactcodes2 as "entity_hasContactCodes" }